"use client";

import React, { useState } from "react";
import SimpleOfferModal from "./SimpleOfferModal";
import { getFinalDiscountTag } from "@/constants/hooks";
import Link from "next/link";

interface Props {
    offer:             any;
    merchantHref:      string;
    imageSrc:          string;
    domain:            string;
    type:              "anchor" | "button";
    buttonClass?:      string;
    isDetail?:         number;        // if 1 → redirect to product detail page
    productDetailUrl?: string | null; // product detail page URL
}

const OfferDetailsToggle = ({
    offer, merchantHref, domain, type, buttonClass,
    imageSrc, isDetail, productDetailUrl,
}: Props) => {
    const [showModal, setShowModal] = useState(false);

    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setShowModal(true);
    };

    const originalPrice   = offer?.original_price ? parseFloat(offer.original_price) : 0;
    const salePrice       = offer?.sale_price      ? parseFloat(offer.sale_price)     : 0;
    const discountPercent = originalPrice > 0 && salePrice > 0
        ? Math.round(((originalPrice - salePrice) / originalPrice) * 100)
        : null;

    const finalDiscountTag = getFinalDiscountTag(
        offer?.offer_title || offer?.offer_detail,
        discountPercent,
    );

    const sharedClass = buttonClass || "";

    /* ── is_detail === 1 + productDetailUrl → direct link ── */
    if (isDetail === 1 && productDetailUrl) {
        return (
            <Link
                href={productDetailUrl}
                className={`no-underline hover:underline underline-offset-2 relative z-[5] ${sharedClass}`}
                style={{ textDecoration: "underline" }}
            >
                View Details
            </Link>
        );
    }

    /* ── Otherwise → SimpleOfferModal ── */
    return (
        <>
            {type === "anchor" ? (
                <span
                    onClick={handleClick}
                    className={`offer-details-anchor cursor-pointer ${sharedClass}`}
                    style={{ textDecoration: "underline" }}
                >
                    View Details
                </span>
            ) : (
                <button
                    onClick={handleClick}
                    className={`offer-details-btn cursor-pointer ${sharedClass}`}
                >
                    View Details
                </button>
            )}

            {showModal && (
                <SimpleOfferModal
                    data={offer}
                    onClose={() => setShowModal(false)}
                    domain={domain}
                    finalDiscountTag={finalDiscountTag}
                    merchantHref={merchantHref}
                />
            )}
        </>
    );
};

export default OfferDetailsToggle;
